import { RootState } from '@/store/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from '@/api/api';
import { EnvironmentConfiguration } from "@/domain/environment.configuration";

/**
 * Client store
 */
export interface EnvironmentConfigurationState {
  environmentConfiguration: EnvironmentConfiguration | undefined;
}

export const state: EnvironmentConfigurationState = {
  environmentConfiguration: undefined
};

export const getters: GetterTree<EnvironmentConfigurationState, RootState> = {
  getEnvironmentConfiguration: state => state.environmentConfiguration
};

export const mutations: MutationTree<EnvironmentConfigurationState> = {
  SET_ENVIRONMENT_CONFIG: (state, environmentConfiguration) => state.environmentConfiguration = environmentConfiguration
};

export const actions: ActionTree<EnvironmentConfigurationState, RootState> = {
  FETCH_ENVIRONMENT_CONFIG({ commit }) {
    return Api.EnvironmentConfig.fetchEnvironmentConfiguration().then(response => {
      commit('SET_ENVIRONMENT_CONFIG', response.environmentConfiguration);
    });
  },
  async SAVE_ENVIRONMENT_CONFIG({ commit }, environmentConfiguration: EnvironmentConfiguration) {
     return await Api.EnvironmentConfig.saveEnvironmentConfiguration(environmentConfiguration);
  }
};

export const EnvironmentConfigurationStore: Module<EnvironmentConfigurationState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
